import {
  createAsyncThunk,
  createSelector,
  createSlice
} from '@reduxjs/toolkit';
import { FETCH_STATUS_ENUM } from '../../../../../common/enums/enums';

import {
  getProductBySku,
  getProducts
} from '../services/kogan-products-service';
import { deleteImageFromS3, listImages } from '../services/s3-service';
import { createTab, TAB_TYPE_ENUM } from './tabsSlice';

const initialState = {
  products: [],
  gridDirtyProducts: [],
  status: 'idle',
  error: null,
};

export const productsSlice = createSlice({
  name: 'koganProducts',
  initialState,
  reducers: {
    addDirtyProduct: (state, action) => {
      const idx = state.gridDirtyProducts.findIndex(
        (p) => p.product_sku === action.payload.product_sku
      );
      if (idx > -1) {
        state.gridDirtyProducts[idx] = action.payload;
      } else {
        state.gridDirtyProducts.push(action.payload);
      }
    },
    clearDirtyProducts: (state) => {
      state.gridDirtyProducts = [];
    },
    updateProduct: (state, action) => {
      const idx = state.products.findIndex(
        (p) => p.product_sku === action.payload.product_sku
      );
      if (idx > -1) {
        state.products[idx] = action.payload;
      }
    },
   
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProducts.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Add any fetched products to the array
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchS3ImagesForTab.pending, (state, action) => {
        const tab = action.meta.arg;
        // const idx = findTabIdxByKey(state, tab.key);
        if (state.tabs.has(tab.key)) state.tabs.get(tab.key).status = FETCH_STATUS_ENUM.LOADING.status;
      })
      .addCase(fetchS3ImagesForTab.fulfilled, (state, action) => {
        // Add any fetched products to the array
        const tab = action.meta.arg;
        // const idx = findTabIdxByKey(state, tab.key);
        if (state.tabs.has(tab.key)) {
          state.tabs.get(tab.key).status = FETCH_STATUS_ENUM.SUCCESS.status;
        state.tabs.get(tab.key).images = action.payload;
        } 

      })
      .addCase(fetchS3ImagesForTab.rejected, (state, action) => {
        const tab = action.meta.arg;
        // const idx = findTabIdxByKey(state, tab.key);
        if (state.tabs.has(tab.key)) state.tabs.get(tab.key).status = FETCH_STATUS_ENUM.FAILED.status;
      })
      
      .addCase(removeImageFromTab.fulfilled, (state, action) => {
        // Add any fetched products to the array
        const tab = action.meta.arg[0];
        // const idx = findTabIdxByKey(state, tab.key);
        if (state.tabs.has(tab.key)) {
          const imageIdx = state.tabs.get(tab.key).images.findIndex(img=>{
            return img === action.payload.url;
          })
          if(imageIdx>-1){
            state.tabs.get(tab.key).images.splice(imageIdx,1);
          }
        } 

      })
      .addCase(removeImageFromTab.rejected, (state, action) => {
        console.error('Error removing image');
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  addDirtyProduct,
  clearDirtyProducts,
  updateProduct,
} = productsSlice.actions;

export default productsSlice.reducer;

// Group thunks here (i.e async dispatchable actions)
export const fetchProducts = createAsyncThunk(
  'productData/fetchProducts',
  async () => {
    const response = await getProducts();
    return response.data.results;
  }
);


export const fetchS3ImagesForTab = createAsyncThunk(
  'product/tab/fetchS3ImagesForTab',
  async (tab)=>{
    const response = await listImages(tab.product.product_sku);
    return response.data.results;
  }
);
export const removeImageFromTab = createAsyncThunk(
  'product/tab/removeImageFromTab',
  async (data)=>{
    await deleteImageFromS3(data[0].product.product_sku,data[1]);
    // no error received, so return file so it can be remved from tab.images array in the reduce
    return data[1];

  }
);
// Group selectors here
export const selectAllProductData = (state) => state.koganProducts.products;
export const getActiveTabKey = (state) => state.koganProducts.activeTabKey;
export const getProductFetchStatus = (state) => state.koganProducts.status;
export const getDirtyProducts = (state) =>
  state.koganProducts.gridDirtyProducts;
export const getActiveProducts = createSelector(
  (state) => state.koganProducts.products,
  (products) => products.filter((p) => p.enabled === true)
);

export const getOOSProducts = createSelector(
  (state) => state.koganProducts.products,
  (products) => products.filter((p) => p.stock < 1)
);

export const isLoading = createSelector(
  (state) => state.koganProducts.status,
  (status) => status === FETCH_STATUS_ENUM.LOADING.status
);

//Group enums here

